export declare type TokenRoleConstants = 'provider'|'store'

export default {
    TokenRoleConstant: {
        ROLE_PROVIDER: 'provider',
        ROLE_STORE: 'store',
    }
}

